import { BaseModel } from '../../common/base/model';

export class OldBankModel extends BaseModel {
  constructor(data) {
    super(data, {
      legacyBankIdentifier: null,
      oldAccountNumber: null
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/oldPortfolio/bank.model.js